export class MapGraphicError extends Error {
  uid: number | undefined = undefined;
  constructor(message: string, uid: number | undefined = undefined) {
    super(message);
    this.uid = uid;
  }
}
